module.exports = __webpack_public_path__ + "static/media/notFound.3f6fbc39.jpg";